<script setup>
import { computed } from 'vue';
import { CORES_STATUS_CONTRATACAO, ICONES_STATUS_CONTRATACAO } from '@/commons/projetos';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_CONTRATACAO[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_CONTRATACAO[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
